import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LiveClassTileInputData } from '../../../shared/types/LiveClassTileInputData';

@Component({
  selector: 'lp2-live-class-state',
  templateUrl: './live-class-state.component.html',
  styleUrls: ['./live-class-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveClassStateComponent {
  @Input() tileData: LiveClassTileInputData;
  @Input() buttonDisabled: boolean;

  @Output() close: EventEmitter<any> = new EventEmitter();

  onClose(event: any) {
    this.close.emit(event);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-tile/live-class-state/live-class-state.component.ts